import { render, staticRenderFns } from "./AppointmentListGroupTitle.vue?vue&type=template&id=c2c6b506&scoped=true&"
import script from "./AppointmentListGroupTitle.vue?vue&type=script&lang=ts&"
export * from "./AppointmentListGroupTitle.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentListGroupTitle.vue?vue&type=style&index=0&id=c2c6b506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c6b506",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow,VSpacer})
